import { PAGE_POSITIONS } from 'types';
import type {
  ExternalLink as ExternalLinkType,
  InternalLink as InternalLinkType
} from 'types/capi/shared';

import useUser from '~/hooks/useUser';

import { getTrackedUrlAndClickRef } from '../../utils/tracking';

type Props = {
  children: JSX.Element | string;
  href: string;
  rel?: string;
  target?: string;
};

export const Hyper = ({ children, ...props }: Props) => {
  return (
    <a
      {...props}
      className="font-semibold underline hover:text-gray-600"
      data-page_position={PAGE_POSITIONS.body}
      data-track_me="true"
    >
      {children}
    </a>
  );
};

export const Internal = ({ link }: { link: InternalLinkType }) => {
  return (
    <Hyper data-cy="internal-link" href={link.path}>
      {link.text}
    </Hyper>
  );
};

export const External = ({ link }: { link: ExternalLinkType }) => {
  const user = useUser();

  const { url } = getTrackedUrlAndClickRef(link, { user });

  return (
    <Hyper
      data-cy="external-link"
      rel="sponsored nofollow noopener"
      target="_blank"
      href={url}
    >
      {link.text}
    </Hyper>
  );
};

export default { External, Hyper, Internal };
